<template>
	<div class="discount-radar">
		<div class="top-banner"></div>
		<div class="title">为你推荐优惠好物</div>
		<div class="app-boom-demo">
			<van-pull-refresh v-model="isLoading" @refresh="onRefresh" :head-height="100">
				<div class="goods">
					<nut-infiniteloading @loadmore="onInfinite" :is-show-mod="true" :has-more="isHasMore" :is-loading="isGoodsLoading" :threshold="200">
						<div class="boom-item-box" v-for="(item, index) in CouponData" :key="index" @click="toDetail(item)">
							<div class="boom-item-content">
								<div class="boom-item-block_left"><van-image width="110" height="110" :src="item.pic + '_270x270.jpg_.webp'" /></div>
								<div class="boom-item-block_2">
									<div class="boom-item-titleWrap-twoline">
										<span>{{ item.itemName }}</span>
									</div>
									<div class="boom-item-tagWrap_2" style="border-color:#fe4800;">
										<span class="boom-item-tag_2" style="color:#fe4800;">{{ item.benefitInfo }}</span>
									</div>
									<div class="boom-item-container">
										<span class="boom-item-rmb" style="color:#fe4800;">¥</span>
										<span class="boom-item-price" style="color:#fe4800;">{{ item.vegasFields.priceAfterAllRights }}</span>
										<div class="boom-item-moneyWrap">
											<span class="boom-item-yuan_2">￥</span>
											<span class="boom-item-money">{{ item.promotionPrice }}</span>
										</div>
									</div>
									<div class="boom-item-tenThousandPiecesSoldOuter">
										<div class="boom-item-tenThousandPiecesSoldWrap"><span class="boom-item-tenThousandPiecesSold">已售9.65万件</span></div>
									</div>
								</div>
							</div>

							<div class="boom-item-primary">
								<span class="boom-item-grab">抢</span>
								<img class="boom-item-jinengicon" src="https://img.alicdn.com/tfs/TB1omCctebviK0jSZFNXXaApXXa-24-40.png" />
							</div>
						</div>
					</nut-infiniteloading>
				</div>
			</van-pull-refresh>

			<van-share-sheet v-model="showShare" :options="options" @select="onSelect" title="分享给好友/自购" description="分享给好友也有佣金哦" />
		</div>
	</div>
</template>

<script>
let currItem = null;
import cstGoods from '@/components/product.vue';

export default {
	name: 'discountRadar',
	data() {
		return {
			isLoading: false,
			CouponData: [],
			page: 1,
			num: 30,
			isHasMore: true,
			isGoodsLoading: false,
			showShare: false,
			options: [
				[
					{ name: '自购下单', icon: 'http://img.cangshutuan.darenjishi.cn/7153ebf90188a5a3/09c0358f84659863.png', type: 'buy' },
					{ name: '微信', icon: 'wechat', type: 'share', channel: 'weixin' },
					{ name: '复制链接', icon: 'link', type: 'copy' },
					{ name: '二维码', icon: 'qrcode', type: 'qrcode' }
				]
			]
		};
	},
	components: { cstGoods },
	created() {
		this.loadData();
	},

	methods: {
		checkLogin() {
			var token = this.$store.getters.accessToken;
			return new Promise((succ, error) => {
				if (!token) {
					suni.showModal({
						title: '温馨提示',
						content: '您还没有登录，请先登录帐号',
						showCancel: true,
						cancelText: '暂不登录',
						confirmText: '立即登录',
						success: res => {
							if (res.confirm) {
								suni.navigateTo({
									url: '/pages/member/ucenter/signIn'
								});
								error(res);
							} else {
								succ(token);
							}
						}
					});
				} else {
					succ(token);
				}
			});
		},
		async create_tpwd(url, title, picture) {
			var token = await this.checkLogin();
			return new Promise((succ, error) => {
				suni.showLoading({
					message: '口令创建中...',
					forbidClick: true,
					duration: 0,
					loadingType: 'spinner'
				});
				this.$Request
					.post('DiscountRadar/create_tpwd', {
						url: url,
						title: title,
						picture: picture,
						token:token,
						sign:this.$Request.md5(token+url)
					})
					.then(res => {
						suni.hideLoading();
						if (res.code == 200) {
							succ(res);
						} else {
							suni.showToast({
								title: res.msg || '淘口令转换失败',
								duration: '5000'
							});
						}
					})
					.catch(err => {
						suni.hideLoading();
					});
			});
		},
		setClipboardData(tbpwd) {
			suni.postMessage({
				data: {
					action: 'api',
					methods: 'setClipboardData',
					params: {
						data: tbpwd
					}
				}
			});
		},
		async onSelect(e) {
			console.log(currItem);
			var res = await this.create_tpwd(currItem.url, currItem.itemName, currItem.pic);
			if (e.type == 'copy') {
				this.setClipboardData(res.data.tbpwd);
			} else if (e.type == 'qrcode') {
				suni.showToast({
					title: '二维码功能正在努力开发中\n内容已复制剪贴板',
					duration: '2000'
				});
				this.setClipboardData(res.data.tbpwd);
			} else if (e.type == 'buy') {
				suni.postMessage({
					data: {
						action: 'api',
						methods: 'nativesupport', // 原生API
						params: {
							api: 'detailPage', // 接口
							params: {
								url: res.data.coupon_click_url || currItem.url,
								openType: 0
							}
						}
					}
				});
			} else if (e.type == 'share') {
				// 执行分享
				if (e.channel == 'weixin') {
					suni.postMessage({
						data: {
							action: 'share', // 执行分享
							methods:"weixin",
							params: {
								api: 'wxContent', // 接口
								params: {
									summary: res.data.tbpwd
								}
							}
						}
					});
				}
			}
			console.log(e);
		},
		toDetail(item) {
			currItem = item;
			this.showShare = true;
		},
		onRefresh() {
			this.isLoading = true;
			this.page = 1;
			this.loadData();
		},
		loadData() {
			this.isGoodsLoading = true;
			this.$Request.post('DiscountRadar/index', { page: this.page, limit: 20 }).then(res => {
				this.isLoading = false;
				this.isGoodsLoading = false;
				if (res.code == 200) {
					res.data.resultList.forEach(item => {
						this.CouponData.push(item);
					});
				} else {
					this.isHasMore = false;
				}
			});
			suni.postMessage({
				data: {
					action: 'api',
					methods: 'setNavigationBarTitle',
					params: {
						title: '优惠雷达'
					}
				}
			});
		},
		onInfinite() {
			this.page = this.page + 1;
			this.loadData();
		},
		detail(e) {
			suni.showLoading();
			suni.navigateTo({
				url: '/pages/detail/goodsinfo?itemid=' + e.itemid + '&goods_type=' + e.shopType
			})
				.then(res => {
					suni.hideLoading();
				})
				.catch(err => {
					suni.hideLoading();
					suni.showToast({
						title: JSON.stringify(err),
						success: err => {
							console.log(err);
						}
					});
				});
		}
	}
};
</script>

<style scoped>
.discount-radar {
	background-color: #f0322c;
	padding-bottom: 20px;
}
.top-banner {
	width: 100%;
	position: relative;
	background-image: url(https://gw.alicdn.com/tfs/TB1z6mHyuH2gK0jSZJnXXaT1FXa-750-450.jpg);
	background-size: 100%;
	background-repeat: no-repeat;
	background-color: #f0322c;
	height: 200px;
}
.title {
	background-image: url(https://gw.alicdn.com/tfs/TB18RSAypY7gK0jSZKzXXaikpXa-667-42.png);
	background-size: 60% 40%;
	width: 100%;
	height: 40px;
	background-repeat: no-repeat;
	background-position: 50%;
	z-index: 3;
	font-size: 12px;
	position: relative;
	color: #fff;
	display: flex;
	align-items: center;
	justify-content: center;
}
.app-boom-demo {
	margin-top: 10px;
}
.boom-item-box {
	width: 95%;
	margin: 0 auto;
	margin-bottom: 10px;
	background-color: #ffffff;
	border-radius: 10px;
	position: relative;
}
.boom-item-content {
	padding: 10px;
	display: flex;
	flex-direction: row;
	align-items: flex-start;
}
.boom-item-block_left {
	margin-right: 10px;
}
.boom-item-block_left img {
	width: 110px;
	height: 110px;
}
.boom-item-block_2 {
}
.boom-item-titleWrap-twoline {
	display: flex;
	align-items: flex-start;
	overflow: hidden;
}
.boom-item-titleWrap-twoline span {
	font-size: 12px;
}
.boom-item-tagWrap_2 {
	border: 1px solid #fe4800;
	font-size: 12px;
	color: #fe4800;
	display: inline-block;
	padding: 3px 5px;
	border-radius: 3px;
}
.boom-item-container {
	display: flex;
	flex-direction: row;
	align-items: flex-end;
	margin-top: 10px;
}

.boom-item-rmb {
	font-weight: 400;
	font-size: 14px;
	white-space: nowrap;
	margin-right: 2px;
}
.boom-item-price {
	font-weight: 500;
	font-size: 18px;
	white-space: nowrap;
}
.boom-item-moneyWrap {
	display: flex;
	align-items: flex-start;
}
.boom-item-yuan_2 {
	margin-left: 5px;
	font-weight: 400;
	font-size: 12px;
	white-space: nowrap;
	color: #999;
}
.boom-item-money {
	font-weight: 500;
	font-size: 12px;
	white-space: nowrap;
	color: #999;
	text-decoration: line-through;
}
.boom-item-tenThousandPiecesSoldOuter {
	display: flex;
	align-items: flex-start;
	flex-direction: row;
}
.boom-item-tenThousandPiecesSoldWrap {
	background-color: hsla(0, 0%, 84.7%, 0);
	overflow: hidden;
	display: flex;
	align-items: flex-start;
	flex-direction: row;
}
.boom-item-tenThousandPiecesSoldWrap span {
	margin-top: 5px;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	color: #999;
	font-size: 12px;
	font-weight: 400;
}
.boom-item-primary {
	display: flex;
	position: absolute;
	align-items: center;
	flex-direction: row;
	background-color: #fe6326;
	padding-top: 1px;
	padding-bottom: 1px;
	padding-right: 5px;
	right: 0px;
	bottom: 20px;
	background-image: linear-gradient(-90deg, #fe4800 0%, #fe7f4c 100%);
	border-top-left-radius: 50px;
	border-bottom-left-radius: 50px;
}
.boom-item-grab {
	margin-left: 10px;
	letter-spacing: 0;
	white-space: nowrap;
	color: #fff;
	font-size: 14px;
	font-weight: 600;
}
.boom-item-jinengicon {
	margin-left: 5px;
	width: 6px;
	height: 8px;
	vertical-align: top;
}
</style>
